import React, {useEffect, useRef} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/App.css';
import {Route, Routes, useLocation, useNavigate} from 'react-router-dom'

import UserMainPg from "./page/web/UserMainPg";
import UserHome from "./page/web/UserHome";
import AdminMainPg from "./page/web/AdminMainPg";
import AdminLoginPg from "./page/web/AdminLoginPg";
import AdminJoinPg from "./page/web/AdminJoinPg";
import UserLoginPg from "./page/web/UserLoginPg";
import UserJoinPg from "./page/web/UserJoinPg";
import UserIdPwFindPg from "./page/web/UserIdPwFindPg";
import UserModiPg from "./page/web/UserModiPg";
import TariffCustomModal from "./components/web/modal/TariffCustomModal";
import OutWaybillModal from "./components/web/modal/OutWaybillModal";
import AdminMergeModal from "./components/web/modal/AdminMergeModal";
import AdminDivideModal from "./components/web/modal/AdminDivideModal";
import AdminRegModal from "./components/web/modal/AdminRegModal";

import AppWrapper from "./AppWrapper";
import UserPayComplPg from "./page/web/UserPayComplPg";
import UserPayWaitPg from "./page/web/UserPayWaitPg";
import UserPayFailedPg from "./page/web/UserPayFailedPg"; // [결제누락 개선] 결제실패 안내페이지
// [구매대행 API] 상점사(쇼핑몰) 화면 — 비토리지 고객화면과 중첩없이 단독 배치
import StoreDashboard from "./page/web/store/Dashboard";
import StoreLoginPg from "./page/web/store/StoreLoginPg";
import StoreJoinPg from "./page/web/store/StoreJoinPg";
import StoreFindPwPg from "./page/web/store/StoreFindPwPg";
import StoreModifyPg from "./page/web/store/StoreModifyPg";
import StoreMailPg from "./page/web/store/StoreMailPg";
import StoreChatPg from "./page/web/store/StoreChatPg";
import StoreApiDocsPg from "./page/web/store/StoreApiDocsPg";
import StoreLinkEntryPg from "./page/web/store/StoreLinkEntryPg";
import CommonLoading from "./components/web/modal/CommonLoading";
import NaverLoginLoading from "./components/web/modal/NaverLoginLoading";
import {BrowserView, MobileView, TabletView, isMobile, isTablet} from 'react-device-detect';

import {PopupProvider} from './components/contextApi/FooterOpenChatContext';
import {ChatProvider} from './components/contextApi/ChatContext';


import i18n from './i18n';
import axios from './services/axiosInstance';
import {ensureAdminToken, resolveAdminAccess, ADMIN_CHECK_INTERVAL_MS} from './services/adminAuth';
import {isAdminProtectedPath} from './services/adminArea';
import {ensureUserToken, USER_CHECK_INTERVAL_MS} from './services/userAuth';
import ErrorPathPg from "./page/web/ErrorPathPg";
import MUserMainPg from "./page/mobile/MUserMainPg";
import MAdminMainPg from "./page/mobile/MAdminMainPg";
import MAdminLoginPg from "./page/mobile/MAdminLoginPg";
import MAdminJoinPg from "./page/mobile/MAdminJoinPg";
import AdminPwFindPg from "./page/web/AdminPwFindPg";
import MAdminPwFindPg from "./page/mobile/MAdminPwFindPg";
import MAdminModiPg from "./page/mobile/MAdminModiPg";
import MAdminMergeModal from "./components/mobile/MAdminMergeModal";
import MAdminDivideModal from "./components/mobile/MAdminDivideModal";
import MAdminRegModal from "./components/mobile/MAdminRegModal";
import MAdminReviewModifyPg from "./page/mobile/MAdminReviewModifyPg";
import MAdminNoticeModifyPg from "./page/mobile/MAdminNoticeModifyPg";
import MAdminFaqModifyPg from "./page/mobile/MAdminFaqModifyPg";
import MUserPayWaitPg from "./page/mobile/MUserPayWaitPg";
import MUserPayComplPg from "./page/mobile/MUserPayComplPg";
import MUserInfoModiPg from "./page/mobile/MUserInfoModiPg";
import MUserIdPwFindPg from "./page/mobile/MUserIdPwFindPg";
import MJoinPg from "./page/mobile/MJoinPg";
import MLoginPg from "./page/mobile/MLoginPg";
import MAdminOrderDetailPg from "./page/mobile/MAdminOrderDetailPg";
import {WebsocketProvider} from "./services/WebsocketContext";
import {StoreWebsocketProvider} from "./services/StoreWebsocketContext";
import AdminNewRegModal from "./components/web/modal/AdminNewRegModal";
import MAdminNoticeWritePg from "./page/mobile/MAdminNoticeWritePg";
import MAdminFaqWritePg from "./page/mobile/MAdminFaqWritePg";
import {HelmetProvider} from "react-helmet-async";
import ErrStatusPg from "./page/web/ErrStatusPg";
import {NetworkStatusProvider} from "./services/NetworkStatusContext";
import SeoHelmet from "./components/SeoHelmet";
import CommonLoadingPg from "./page/web/CommonLoadingPg";
import PaymentLoading from "./components/web/modal/PaymentLoading";


function App() {

    const navigate = useNavigate();
    const location = useLocation();

    // 사용자
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');
    // 관리자
    const adminLCAT = localStorage.getItem('adminToken');

    // 현재 브라우저위치
    const pathName = window.location.pathname;

    /*
     * 토큰 점검 타이머가 '현재 경로' 를 보긴 해야 하는데, 경로를 의존성에 넣으면
     * 화면을 이동할 때마다 타이머가 재생성되면서 즉시 점검이 한 번 더 돌아버린다.
     * (운영에서 메인화면 진입/이동마다 /member/reissue 가 반복 호출된 원인)
     * 그래서 경로는 ref 로만 전달하고, 타이머는 의존성에서 경로를 뺀다.
     */
    const pathNameRef = useRef(pathName);
    useEffect(() => {
        pathNameRef.current = pathName;
    }, [pathName]);

    /*
     * ══════════════════════════════════════════════════════════════════════════
     *  사용자 토큰 자동 재발급
     * ══════════════════════════════════════════════════════════════════════════
     *  [예전 문제]
     *   AT 는 1시간인데 '1시간마다 점검 + 1시간 경과 시 갱신' 이라
     *   갱신이 항상 만료 이후에 돌았다. 최악의 경우 2시간 가까이
     *   만료된 토큰으로 지내게 되어, 조회가 비거나 저장이 조용히 실패했다.
     *   (주석에는 '30분 경과 시 재발급' 이라 적혀 있었는데 코드는 1시간이었다)
     *
     *   또 Authorization 응답헤더를 검증하지 않고 저장해서
     *   값이 비면 "null" 이라는 문자열이 들어갔다. 그 값은 truthy 라
     *   라우트 가드를 통과해버려 모든 API 가 401 인 상태가 계속되었다.
     *
     *  [지금]
     *   5분마다 점검하고 50분이 지나면 미리 갱신한다. (최대 경과 55분 < AT 1시간)
     *   판단과 재발급은 services/userAuth.js 에 모아두고 여기서는 호출만 한다.
     *   '로그인 유지' 에 따른 localStorage / sessionStorage 분기와
     *   30일 경과 자동로그아웃은 기존 동작을 그대로 유지한다.
     *
     *  [점검 시점]
     *   1) 화면에 들어온 직후 한 번
     *   2) 그 뒤 5분마다
     *   3) 다른 탭/절전에서 돌아올 때 (visibilitychange)
     *      오래 켜둔 창은 브라우저가 타이머를 늦추거나 멈추므로
     *      돌아온 순간 바로 확인해야 만료된 채 조작하는 일이 없다.
     */
    useEffect(() => {
        if (!LCAT && !SSAT) return;

        let alive = true;
        let lastCheckAt = 0;
        const check = () => {
            if (!alive) return;
            // 관리자 화면에서는 관리자 타이머가 담당한다 (경로는 ref 로 본다 — 위 주석 참고)
            if (pathNameRef.current.startsWith('/btcorpad')) return;
            lastCheckAt = Date.now();
            // 필요할 때만(50분 경과) 실제로 재발급한다
            ensureUserToken().catch(() => { /* 실패해도 화면은 유지한다 */ });
        };

        check();
        const interval = setInterval(check, USER_CHECK_INTERVAL_MS);

        /*
         * 탭 복귀 시 점검 — 단, 점검주기보다 짧은 간격으로는 돌지 않게 제한한다.
         *  오래 켜둔 창은 브라우저가 타이머를 늦추거나 멈추므로 복귀 점검은 꼭 필요하다.
         *  그런데 제한이 없으면 탭을 왔다갔다 할 때마다 재발급이 나가고,
         *  서버는 재발급마다 RT 를 교체하므로 불필요한 교체가 반복된다.
         *  (운영에서 재발급 호출이 과하게 몰린 원인 중 하나였다)
         */
        const onVisible = () => {
            if (document.visibilityState !== 'visible') return;
            if (Date.now() - lastCheckAt < USER_CHECK_INTERVAL_MS) return;
            check();
        };
        document.addEventListener('visibilitychange', onVisible);

        return () => {
            alive = false;
            clearInterval(interval);
            document.removeEventListener('visibilitychange', onVisible);
        };
        // 경로를 의존성에 넣지 않는다 — 화면이동마다 즉시점검이 또 도는 것을 막는다
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [LCAT, SSAT])


    /*
     * ══════════════════════════════════════════════════════════════════════════
     *  관리자 토큰 자동 재발급
     * ══════════════════════════════════════════════════════════════════════════
     *  [예전 문제]
     *   이 타이머가 'adminLastLoginTime' 이 아니라 사용자 키인 'lastLoginTime' 을
     *   읽고 있었다. 관리자만 로그인한 브라우저에는 그 키가 없으므로
     *   항상 "로그인 시간정보 null" 로 조기 종료되어 재발급이 한 번도 돌지 않았다.
     *   그래서 AT(1시간)가 만료되면 모든 API 가 401 이 되어 로그인 화면으로 튕겼다.
     *
     *   또 사용자 계정으로도 로그인한 브라우저에서는 사용자의 옛 lastLoginTime 을
     *   읽어 '30일 경과' 로 오판하고 관리자 토큰을 지워버리는 일까지 있었다.
     *
     *  [지금]
     *   관리자는 localStorage 만 쓰므로(adminToken / adminLastLoginTime)
     *   사용자 키와 sessionStorage 는 보지 않는다.
     *   판단과 재발급은 services/adminAuth.js 에 모아두고 여기서는 호출만 한다.
     *
     *  [점검 시점]
     *   1) 관리자 화면에 들어온 직후 한 번
     *   2) 그 뒤 5분마다
     *   3) 다른 탭/절전에서 돌아올 때 (visibilitychange)
     *      12시간 넘게 켜둔 창은 브라우저가 타이머를 늦추거나 멈추므로
     *      돌아온 순간 바로 확인해야 만료된 채 조작하는 일이 없다.
     */
    useEffect(() => {
        if (!adminLCAT) return;

        let alive = true;
        let lastCheckAt = 0;
        const check = () => {
            if (!alive) return;
            // 관리자 화면에서만 돈다 (경로는 ref 로 본다 — 위 주석 참고)
            if (!pathNameRef.current.startsWith('/btcorpad')) return;
            lastCheckAt = Date.now();
            // 필요할 때만(50분 경과) 실제로 재발급한다
            ensureAdminToken().catch(() => { /* 실패해도 화면은 유지한다 */ });
        };

        check();
        const interval = setInterval(check, ADMIN_CHECK_INTERVAL_MS);

        /*
         * 탭 복귀 시 점검 — 점검주기보다 짧은 간격으로는 돌지 않게 제한한다.
         * (제한이 없으면 탭 전환마다 재발급이 나가 RT 교체가 불필요하게 반복된다)
         */
        const onVisible = () => {
            if (document.visibilityState !== 'visible') return;
            if (Date.now() - lastCheckAt < ADMIN_CHECK_INTERVAL_MS) return;
            check();
        };
        document.addEventListener('visibilitychange', onVisible);

        return () => {
            alive = false;
            clearInterval(interval);
            document.removeEventListener('visibilitychange', onVisible);
        };
        // 경로를 의존성에 넣지 않는다 — 화면이동마다 즉시점검이 또 도는 것을 막는다
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adminLCAT])

    /*
     * ════════════════════════════════════════════════════════════════════════════
     *  관리자 영역 진입 관문 — 여기가 실제 '강제 로그인' 을 담당한다
     * ════════════════════════════════════════════════════════════════════════════
     *  [예전 코드와 그래서 난 사고]
     *      if (pathName.startsWith('/btcorpad') && !adminLCAT) navigate('/btcorpad-login')
     *
     *   두 가지가 비어 있었다.
     *    1. '토큰이 있는지' 만 봤다. 만료됐는지도, 그것이 관리자 토큰인지도 보지 않았다.
     *       그래서 쿠키가 섞여 관리자 자리에 '사용자 토큰' 이 들어앉았을 때 그대로
     *       통과시켰고, 관리자 화면이 사용자 권한으로 동작해 주문서 채팅이 사용자
     *       명의로 전송되었다.
     *    2. 의존성이 [adminLCAT] 뿐이라 '관리자 경로로 이동하는 것' 자체로는 다시
     *       검사되지 않았다. 사용자 화면에서 관리자 화면으로 넘어가도 관문이 열리지
     *       않았다 — '로그아웃된 줄 모르고 쓰는' 상태가 여기서 만들어졌다.
     *
     *  [지금]
     *   resolveAdminAccess() 가 영역(admin) · 만료 · 재발급까지 판단한다.
     *   · 유효하면 그대로 통과 (서버를 두드리지 않는다)
     *   · AT 만 만료됐으면 조용히 재발급해 통과 (작업중 튕기지 않는다)
     *   · 관리자 토큰이 아니거나 재발급도 실패하면 로그인 화면으로 보낸다
     *
     *  [로그인/가입/비번찾기 화면은 제외해야 한다]
     *   '/btcorpad-login' 도 '/btcorpad' 로 시작한다. 제외하지 않으면 로그인 화면에서
     *   스스로를 향해 계속 이동하게 된다.
     * ════════════════════════════════════════════════════════════════════════════
     */
    useEffect(() => {
        if (!isAdminProtectedPath(pathName)) return;

        let alive = true;
        const sendToLogin = () => {
            if (alive) navigate('/btcorpad-login', {replace: true});
        };

        resolveAdminAccess()
            .then((allowed) => {
                if (!allowed) sendToLogin();
            })
            .catch(() => sendToLogin());   // 판단 자체가 실패하면 들여보내지 않는다

        return () => { alive = false; };
        // 경로가 바뀔 때(관리자 영역 진입)와 토큰이 바뀔 때 모두 다시 본다
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathName, adminLCAT])


    /** Branch.io 시작*/
        // 10자리 숫자생성기
    const generateState = () => {
            const today = new Date();
            const year = today.getFullYear().toString().slice(2); // 연도 마지막 2자리
            const month = (today.getMonth() + 1).toString().padStart(2, '0'); // 월 (2자리)
            const day = today.getDate().toString().padStart(2, '0'); // 일 (2자리)

            const dateString = `${year}${month}${day}`; // yyMMdd 형식
            const randomLong = Math.floor(Math.random() * 10_000); // 4자리 랜덤 숫자
            const randomNumber = randomLong.toString().padStart(10, '0');
            return dateString + randomNumber;
        }

    const trafficSendToServer = (clickId, channelType, platformType) => {
        try {
            axios.post('/channelLog/saveAdData', {
                clickId: clickId,
                eventType: '0', // Traffic
                channelType: channelType,
                platformType: platformType,
                paymentPrice: 0
            }).then(res => {
                console.log("유입경로 저장완료", res.data);
            }).catch(err => {
                console.log("유입경로 저장실패", err);
            });
        } catch (error) {

        }
    }

    // Branch.io 연동 광고유입추적
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const isNaver = urlParams.get('bt_sub2') === 'naver';
        const isEtcAds = urlParams.get('bt_sub2') === 'google' || urlParams.get('bt_sub2') === 'youtube' ||
            urlParams.get('bt_sub2') === 'facebook' || urlParams.get('bt_sub2') === 'instagram' || urlParams.get('bt_sub2') === 'tiktok'
            || urlParams.get('bt_sub2') === 'threads' || urlParams.get('bt_sub2') === 'twitter' || urlParams.get('bt_sub2') === 'gpt'
            || urlParams.get('bt_sub2') === 'gemini' || urlParams.get('bt_sub2') === 'community'

        let channelType;
        let platformType = navigator.userAgent.includes('Mobi') ? '2' : '1';

        if (!urlParams) {
            console.log('Failed to extract param:', urlParams);
            return;
        }

        if (isNaver) {
            const clickId = generateState();
            localStorage.setItem('bt_sub1', clickId);
            localStorage.setItem('bt_sub2', 'naver');
            trafficSendToServer(clickId, '5', platformType);
        } else if (isEtcAds) {
            const clickId = urlParams.get('bt_sub1') || generateState(); // gclid, fbclid 등 광고채널의 고유생성값
            const adChannel = urlParams.get('bt_sub2');
            localStorage.setItem('bt_sub1', clickId);
            localStorage.setItem('bt_sub2', adChannel);

            // 광고채널 타입
            if (adChannel.includes("google")) channelType = '1'
            else if (adChannel.includes("youtube")) channelType = '2'
            else if (adChannel.includes("facebook")) channelType = '3'
            else if (adChannel.includes("instagram")) channelType = '4'
            else if (adChannel.includes("naver")) channelType = '5'
            else if (adChannel.includes("tiktok")) channelType = '6'
            else if (adChannel.includes("threads")) channelType = '7'
            else if (adChannel.includes("twitter")) channelType = '8'
            else if (adChannel.includes("gpt")) channelType = '9'
            else if (adChannel.includes("gemini")) channelType = '10'
            else if (adChannel.includes("community")) channelType = '11'

            trafficSendToServer(clickId, channelType, platformType);
        }
    }, []);
    /** Branch.io 종료*/



    // localStorage 저장언어조회
    useEffect(() => {
        if (!pathName.startsWith('/btcorpad')) {
            const currentLanguage = localStorage.getItem('lang') || 'ko';
            i18n.changeLanguage(currentLanguage);
        }
    }, []);

    useEffect(() => {
        const detectDeviceType = () => {
            if (window.navigator.userAgent.includes('ReactNative')) {
                return 'A'; //App
            } else if (window.navigator.userAgent.includes('Mobi')) {
                return 'M'; //웹앱
            } else {
                return 'P'; //PC
            }
        };

        const deviceType = detectDeviceType();
        sendAccessInfo(deviceType);
    }, []);

    const sendAccessInfo = async (deviceType) => {
        try {
            const response = await axios.post('/init/accessInfo', {
                accessTime: new Date().toISOString(),
                machFl: deviceType,
            });
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const currentPath = location.pathname;
        const allowedPaths = ["/specific-path", "/another-path"];

        if (allowedPaths.includes(currentPath)) {
            const params = new URLSearchParams(window.location.search);
            const source = params.get("source");

            if (source) {
                axios.post("/api/socialInit/socialTrack", { platform: source })
                    .then(() => console.log(`${source}에서 유입 기록`))
                    .catch(error => console.error("유입 기록 오류: ", error));
            }
        }
    }, [location]);


    return (
        <HelmetProvider>
            <SeoHelmet />
        <NetworkStatusProvider>
        <WebsocketProvider>
            {/* [구매대행 API] 상점사 채팅 전용 웹소켓 - 회원용 커넥션과 완전히 분리된다.
                구독자가 생길 때만 연결되므로 일반 회원 화면에는 아무 영향이 없다. */}
            <StoreWebsocketProvider>
            <ChatProvider>
            <PopupProvider>
                <AppWrapper>
                    <div className="app">
                        {/*PC VIEW*/}
                        {/*{!isMobileOrTablet && (*/}
                        <BrowserView>
                            <Routes>
                                <Route path="/" element={<UserHome key="userHome"/>}/> {/*고객 통합 메인화면(리뉴얼)*/}
                                <Route path="/*" element={<UserMainPg key={location.pathname} />}/> {/*고객페이지*/}
                                <Route path="/btcorpad/*" element={<AdminMainPg key={location.pathname}/>}/> {/*관리자페이지*/}

                                <Route path="/UserLoginPg" element={<UserLoginPg key={location.pathname}/>}/>
                                <Route path="/UserJoinPg" element={<UserJoinPg key={location.pathname}/>}/>
                                <Route path="/UserIdPwFindPg" element={<UserIdPwFindPg/>}/>
                                <Route path="/UserModiPg" element={<UserModiPg key={location.pathname}/>}/>
                                <Route path="/UserPayComplPg" element={<UserPayComplPg/>}/>
                                <Route path="/UserPayWaitPg" element={<UserPayWaitPg/>}/>
                                <Route path="/UserPayFailedPg" element={<UserPayFailedPg/>}/>
                                {/* [구매대행 API] 상점사(쇼핑몰) 화면 - 단독 배치 */}
                                <Route path="/store/api/dashboard" element={<StoreDashboard/>}/>
                                <Route path="/store/api/login" element={<StoreLoginPg/>}/>
                                <Route path="/store/api/join" element={<StoreJoinPg/>}/>
                                <Route path="/store/api/findpw" element={<StoreFindPwPg/>}/>
                                <Route path="/store/api/modify" element={<StoreModifyPg/>}/>
                                <Route path="/store/api/mail" element={<StoreMailPg/>}/>
                                <Route path="/store/api/chat" element={<StoreChatPg/>}/>
                                <Route path="/store/api/docs" element={<StoreApiDocsPg/>}/>
                                <Route path="/store/link" element={<StoreLinkEntryPg/>}/>

                                <Route path="/api/btoragePay/PaymentLoading" element={<PaymentLoading/>}/>
                                <Route path="/PaymentLoading" element={<PaymentLoading/>}/>

                                <Route path="/btcorpad-login" element={<AdminLoginPg/>}/>
                                <Route path="/btcorpad-join" element={<AdminJoinPg/>}/>
                                <Route path="/btcorpad-pwFind" element={<AdminPwFindPg/>}/>
                                <Route path="/btcorpad/btad-WabillReg" element={<OutWaybillModal/>}/>
                                <Route path="/btcorpad/btad-TariffReg" element={<TariffCustomModal/>}/>
                                <Route path="/btcorpad/btad-Merge" element={<AdminMergeModal/>}/>
                                <Route path="/btcorpad/btad-Divide" element={<AdminDivideModal/>}/>
                                <Route path="/btcorpad/btad-Payreg" element={<AdminRegModal/>}/>
                                {/*<Route path="/btcorpad/btad-Payreg2" element={<AdminNewRegModal/>}/>*/}

                                <Route path="/CommonLoading" element={<CommonLoading/>}/>
                                <Route path="*" element={<ErrorPathPg/>}/>
                                <Route path="/ErrStatusPg" element={<ErrStatusPg/>}/>
                            </Routes>
                        </BrowserView>
                        {/*)}*/}
                        {/*Mobile & Tablet VIEW*/}
                        {(isMobile || isTablet) && (
                        // {isMobileOrTablet && (
                        <MobileView style={{height: 'calc(var(--vh, 1vh) * 100)'}}>
                            <Routes>
                                {/*User: 반응형으로 리뉴얼된 '웹' 컴포넌트를 모바일에서도 동일 사용
                                   (기존 적응형 M* 사용자 컴포넌트 대신 PC/모바일 공통 렌더)*/}
                                <Route path="/" element={<UserHome key="userHome"/>}/>
                                <Route path="/*" element={<UserMainPg key={location.pathname}/>}/>
                                <Route path="/UserLoginPg" element={<UserLoginPg key={location.pathname}/>}/>
                                <Route path="/UserJoinPg" element={<UserJoinPg key={location.pathname}/>}/>
                                <Route path="/UserIdPwFindPg" element={<UserIdPwFindPg/>}/>
                                <Route path="/UserModiPg" element={<UserModiPg key={location.pathname}/>}/>
                                <Route path="/UserPayComplPg" element={<UserPayComplPg/>}/>
                                <Route path="/UserPayWaitPg" element={<UserPayWaitPg/>}/>
                                <Route path="/UserPayFailedPg" element={<UserPayFailedPg/>}/>
                                {/* [구매대행 API] 상점사(쇼핑몰) 화면 - 단독 배치 */}
                                <Route path="/store/api/dashboard" element={<StoreDashboard/>}/>
                                <Route path="/store/api/login" element={<StoreLoginPg/>}/>
                                <Route path="/store/api/join" element={<StoreJoinPg/>}/>
                                <Route path="/store/api/findpw" element={<StoreFindPwPg/>}/>
                                <Route path="/store/api/modify" element={<StoreModifyPg/>}/>
                                <Route path="/store/api/mail" element={<StoreMailPg/>}/>
                                <Route path="/store/api/chat" element={<StoreChatPg/>}/>
                                <Route path="/store/api/docs" element={<StoreApiDocsPg/>}/>
                                <Route path="/store/link" element={<StoreLinkEntryPg/>}/>

                                <Route path="/api/btoragePay/PaymentLoading" element={<PaymentLoading/>}/>
                                <Route path="/PaymentLoading" element={<PaymentLoading/>}/>
                                {/*Admin: 관리자 화면은 리뉴얼 대상 외 → 기존 모바일 전용(M*) 유지*/}
                                <Route path="/btcorpad/*" element={<MAdminMainPg/>}/> {/*관리자메인*/}
                                <Route path="/btcorpad-login" element={<MAdminLoginPg/>}/> {/*로그인페이지*/}
                                <Route path="/btcorpad-join" element={<MAdminJoinPg/>}/> {/*회원가입페이지*/}
                                <Route path="/btcorpad-pwFind" element={<MAdminPwFindPg/>}/> {/*비밀번호찾기 페이지*/}
                                <Route path="/btcorpad/btad-MergeM" element={<MAdminMergeModal/>}/> {/*비용등록*/}
                                <Route path="/btcorpad/btad-DivideM" element={<MAdminDivideModal/>}/> {/*분리*/}
                                <Route path="/btcorpad/btad-PayregM" element={<MAdminRegModal/>}/> {/*통합*/}
                                <Route path="/btcorpad/orderdtmodi/:ordNum" element={<MAdminOrderDetailPg/>}/> {/*주문상세*/}
                                {/*<Route path="/btcorpad/orderPayDt/:seqNum" element={<MAdminDeliveryPriceDtModal/>}/> /!*주문상세*!/*/}
                                <Route path="/adminInfoModi" element={<MAdminModiPg/>}/> {/*프로필수정*/}
                                <Route path="/adminreview-modify/:seqNum" element={<MAdminReviewModifyPg/>}/>{/*이용후기수정*/}
                                <Route path="/adminnotice-modify/:seqNum" element={<MAdminNoticeModifyPg/>}/> {/*공지사항수정*/}
                                <Route path="/adminnotice-write" element={<MAdminNoticeWritePg/>}/> {/*공지사항등록*/}
                                <Route path="/adminfaq-modify/:seqNum" element={<MAdminFaqModifyPg/>}/> {/*FAQ수정*/}
                                <Route path="/adminfaq-write" element={<MAdminFaqWritePg/>}/> {/*FAQ작성*/}

                                <Route path="/CommonLoading" element={<CommonLoading/>}/>
                                <Route path="*" element={<ErrorPathPg/>}/>
                                <Route path="/ErrStatusPg" element={<ErrStatusPg/>}/>
                            </Routes>
                        </MobileView>
                        )}
                    </div>
                </AppWrapper>
            </PopupProvider>
            </ChatProvider>
            </StoreWebsocketProvider>
        </WebsocketProvider>
        </NetworkStatusProvider>
        </HelmetProvider>
    );
}

export default App;
